import * as React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import { GetString } from '../../components/StringResourceManager';
// Constants
import { APP_TITLE } from '../../utils/constants';
import NBCItemsGrid from '../../components/NBC/NBCItemsGrid';
import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import { getDivisionList } from '../../store/Assets/AssetsActions';
import { useEffect } from 'react';
import { Dispatch } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      '& > *': {
        margin: theme.spacing(2),
      },
    },
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
  }),
);

export default function NBC() {
  const classes = useStyles();

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getDivisionList(dispatch);
    }
    return () => {};
  }, [isLogin]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_NBC')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header open={true} pageDisplayed={GetString('PAGE_TITLE_NBC')} />
      <Paper className={classes.paperGrid}>
        <NBCItemsGrid />
      </Paper>
    </>
  );
}
